import { httpGet } from 'common/helpers/http'

import { ResolveSlugV4DTO } from 'publication-types'
import { isFeatureEnabled } from 'common/feature-togglings/features'
import { DataLoaderGlobalParams } from 'common/data/resources'

export function resolveSlug(
    services: DataLoaderGlobalParams,
    // The original path, which has not yet been altered by getSiteSection
    originalPath: string,
    // Should be passed in if the section was prepended, otherwise undefined
    domainedSection: string | undefined
) {
    const includePremiumQuery = isFeatureEnabled(
        services.store.getState().toggles,
        'digital-subscriptions',
        false
    )
        ? '&include_premium=true'
        : ''

    const expectedSectionQuery = domainedSection ? `&section=${domainedSection}` : ''

    const cleanSlug = originalPath[0] === '/' ? originalPath.slice(1) : originalPath
    const path = `v4/resolve?slug=/${cleanSlug}${includePremiumQuery}${expectedSectionQuery}&include_meta`
    return httpGet({
        log: services.log,
        validate,
        baseUrl: services.config.contentApi,
        path,
        customHeaders: {
            caller: services.config.apiCallerHeader,
        },
    })
}

export const validate = (value: any): ResolveSlugV4DTO => {
    return value
}
